module.exports = __webpack_public_path__ + "img/as.bbe697d2.svg";